import { type ApolloError, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

const GET_AR_QUALIFICATION_NUMBERS = gql`
  query ($filter: OfferedApplicationFilter!) {
    qualificationApplicationList(filter: $filter) {
      paginator {
        count
      }
    }
    visaApplicationList(filter: $filter) {
      paginator {
        count
      }
    }
  }
`;

type GetARQualificationNumbers = {
  qualificationNumbers: number[];
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetARQualificationNumbers = (
  filters: any[],
): GetARQualificationNumbers => {
  const { data, loading, error } = useQuery(GET_AR_QUALIFICATION_NUMBERS, {
    // TODO:
    variables: { filter: {} },
  });

  const results = [
    data?.qualificationApplicationList?.paginator?.count,
    data?.visaApplicationList?.paginator?.count,
  ];

  return { qualificationNumbers: results, loading, error };
};
